$(function () {
	(function () {//init preferences
		getSpeedVal();//if empty, will be set to default value
	})();

	(function () {//init strictness — UNCONDITIONAL at page load, not deferred to dialog-open
		//(contrast ensureStrictnessSlider below): training_session.js's getRepetition() can be
		//read before Settings is ever opened this visit, so the hidden repetition-fold-in radio
		//and the live caption must already be correct on first paint, not just after a click.
		//#strictnessSliderId's own th:value is the source PageController resolved server-side;
		//this only fills in the two things Thymeleaf did not render (the fold-in radio, the
		//caption text).
		setStrictnessVal(getStrictnessVal());
	})();

	var dlgHtmlObj = $("#dlgPrefId");

	function getSpeedVal() {
		return $("#speedValId").text();
	}

	function setSpeedVal(speedVal) {
		$("#speedValId").text(speedVal);
	}

	// Strictness slider (garden-srs-redesign-spec.md §2/§3, P5). Repetition (showings-planned)
	// FOLDS IN: the notch is the only thing shown and dragged, and this file is now the SOLE
	// writer of the legacy `repetition` attr too — the three visible radios are gone.
	// training_session.js's getRepetition() still reads
	// $("input[name='repetition']:checked").val() UNCHANGED (falls back to 1 if nothing
	// matches). The least invasive shape that leaves it untouched: keep ONE real radio (not
	// type=hidden, so :checked still applies) permanently checked, its value kept as
	// STRICTNESS.showingsFor(notch) by setStrictnessVal below — every drag, page-load init, and
	// dialog OK all funnel through this one function, so the radio can never drift from the
	// pill's own value.
	// Same #strictnessValId-is-the-source-of-truth idiom as getSpeedVal/setSpeedVal above (see
	// ensureSlider's comment): the range only ever WRITES into the pill (on drag) or reads OUT
	// of it (on open-sync, OK), never the reverse, so a server-echoed value that differs from
	// what was sent (OK's callback below) cannot leave the pill and the slider disagreeing.
	function getStrictnessVal() {
		return parseInt($("#strictnessValId").text(), 10);
	}

	function setStrictnessVal(notch) {
		$("#strictnessValId").text(notch);
		$("#strictnessCaptionId").text(STRICTNESS.captionFor(notch));
		// .prop both together: a stray value under checked=false (or vice versa) would still
		// fail the :checked selector and silently fall back to getRepetition()'s default of 1.
		$("#repetitionFoldInId").prop("value", STRICTNESS.showingsFor(notch)).prop("checked", true);
	}

	// One pref dropdown (Exercise Speed + the drill-behaviour toggles), two gear buttons that trigger it: one on the
	// settings band (pre-exercise view) and one on the progress band (during the drill). They are
	// never visible at the same time, so we share a single dialog + LrnDialog and just re-anchor it
	// under whichever gear was clicked. activeButton drives the active-highlight and close callback.
	var activeButton = null;
	var ctrl = {
		onOpen: function () { if (activeButton) { activeButton.addClass("pl-btn-toggle-active"); } },
		onClose: function () { if (activeButton) { activeButton.removeClass("pl-btn-toggle-active"); } },
		onOk: function () {
			// Speed is applied on OK; every other row in the dialog is a live toggle that persists
			// from its own change handler below, so nothing else to do here.
			ajaxPostUserAttr("speed", getSpeedVal(), function (data) {
				setSpeedVal(data.speed);
			});
			// Strictness applies on OK too (same precedent, not a live toggle): the notch itself,
			// AND the repetition fold-in it computes — two attrs, two independent posts through
			// ajaxPostUserAttr's own per-attribute queue (see util.js).
			var strictnessNotch = getStrictnessVal();
			ajaxPostUserAttr("strictness", strictnessNotch, function (data) {
				setStrictnessVal(parseInt(data.strictness, 10));
			});
			ajaxPostUserAttr("repetition", STRICTNESS.showingsFor(strictnessNotch));
			return true;
		}
	};

	var dlgJsObj;
	function ensureDialog() {
		if (!dlgJsObj) {
			dlgJsObj = new LrnDialog(ctrl, dlgHtmlObj, {});
			dlgJsObj.actionUrl = "pref-url";
		}
	}

	// Native <input type=range> (Phase 4 retired the jQuery UI slider). min/max/step + the initial
	// value live in the markup; here we wire the live-drag listener ONCE, then sync the handle to the
	// current value on each open. #speedValId stays the single source of truth — the drill and the
	// OK-save both read speed from it, so the range only ever writes INTO it (never the reverse).
	var sliderInited = false;
	function ensureSlider() {
		if (sliderInited) { return; }
		$("#speedSliderId").on("input", function () {
			setSpeedVal(this.value);
		});
		sliderInited = true;
	}

	// Same one-time-wire idiom as ensureSlider, kept as its own flag/function rather than folded
	// into it: the two sliders are unrelated controls that happen to share a dialog, and a future
	// removal of one must not risk silently un-wiring the other.
	var strictnessSliderInited = false;
	function ensureStrictnessSlider() {
		if (strictnessSliderInited) { return; }
		$("#strictnessSliderId").on("input", function () {
			setStrictnessVal(this.value);
		});
		strictnessSliderInited = true;
	}

	function openPrefFrom(button, holder) {
		ensureSlider();
		$("#speedSliderId").val(getSpeedVal());   //sync handle to the current value

		ensureStrictnessSlider();
		$("#strictnessSliderId").val(getStrictnessVal());   //sync handle to the current value

		ensureDialog();
		activeButton = button;
		holder.append(dlgHtmlObj);                    //re-anchor the shared dialog under this gear
		dlgHtmlObj.css("top", "120%");                //move below the button with some additional gap
		dlgHtmlObj.css("left", -dlgHtmlObj.width());  //move to the left of the button
		dlgJsObj.open(button[0]);                     //the gear joins the layer's anchors
	}

	function wireGear(buttonId, holderId) {
		var button = $("#" + buttonId);
		var holder = $("#" + holderId);
		if (!button.length) { return; }
		button.assignTooltip("settings_tooltip");
		button.click(function (e) {
			openPrefFrom(button, holder);
			e.preventDefault();
			e.stopPropagation();
		});
	}

	wireGear("prefButtonId", "prefBoxId");       //settings band (pre-exercise view)
	wireGear("prefButtonExId", "prefBoxExId");   //progress band (during the drill)

	// Every row explains itself (owner ask 2026-09-01): ONE delegate over the dialog's content,
	// keyed off the row's data-tip-key in main.html, so a new row declares its explanation beside
	// its label and no ID list here grows with it. Delegated rather than attached per row so the
	// anchor is always the ROW (closest("[data-tip-key]")): the box holds still while the pointer
	// crosses from the label to its switch, and a keyboard focus on the switch (focusin bubbles)
	// shows the row's tip too. The listener lives on the content node, which survives the dialog
	// being re-parented under either gear (openPrefFrom appends the same element).
	// The four Answers rows add data-tip-off-key: while updateReverseDependents (main.js) has the
	// row greyed, that line is appended, so the greying says why instead of just being grey.
	// Adaptive speed quotes the live learn.exercise.* tuning (exercise_tuning, inlined by
	// PageController) rather than restating its defaults — the same numbers training_session.js
	// runs the timer from, so the tip cannot drift from the drill.
	// Placement: BESIDE the dialog, not below the row. The dialog is a column of rows and hugs
	// the right edge of the window, so the engine's default "below" parks a 16em box over the
	// very rows the reader is scanning next (the strictness tip covered the whole Verbs group);
	// "left" + align:"start" puts it in the empty space beside the dialog, top-flush with its
	// row, like a margin note. The gap clears the dialog's own frame and padding. Narrow
	// windows with no room on the left fall back to below.
	var prefContent = document.getElementById("dlgPrefContentId");
	if (prefContent) {
		PL.tip.delegate(prefContent, "[data-tip-key]", {
			sides: ["left", "below"], gap: 28,
			content: function (el) {
				var key = el.getAttribute("data-tip-key");
				var text = getRes(key);
				if (key === "prefAdaptiveSpeed_tooltip") {
					var tuning = window.exercise_tuning || {};
					text = strFormat(text, tuning.speedUpStepPercent, tuning.speedUpMaxSteps);
				}
				var offKey = el.getAttribute("data-tip-off-key");
				if (offKey && el.classList.contains("subduedClass")) {
					text += "<p>" + getRes(offKey);
				}
				return text;
			}
		});
	}

	// Exercise-behaviour settings are live toggles: persist on change, and the training session
	// reads their current state straight from the DOM on every answer/timer start.
	$("#adaptiveSpeedId").change(function () {
		ajaxPostUserAttr("adaptiveSpeed", this.checked);
	});
	$("#strictCapsId").change(function () {
		ajaxPostUserAttr("strictCaps", this.checked);
	});
	$("#drillArticleId").change(function () {
		ajaxPostUserAttr("drillArticle", this.checked);
	});
	// Phrase-drill answer modes (design/phrase-drill-design.md §7). Both were JS constants while the
	// settings layout was open; they are ordinary live toggles now, read from the DOM per card like
	// Strict caps. Which of the two is greyed out is decided by the DIRECTION, not by these boxes,
	// so neither needs a callback into main.js.
	$("#selfCheckPrefId").change(function () {
		ajaxPostUserAttr("selfCheck", this.checked);
	});
	$("#gapPhrasesId").change(function () {
		ajaxPostUserAttr("gapPhrases", this.checked);
	});
	// NB practice direction and "sound only" are NOT here any anymore: both graduated to the Start
	// band's direction cluster (design docs/design/practice-direction-controls.md §2), and main.js
	// owns both preferences end to end — plSetPracticeDirection / plSetAudioCue persist the
	// practiceDirection and defSoundOnly attrs themselves. One writer each, so a control and its
	// stored value cannot fork.
	// NB the repetition trio's own change handler is gone with the radios (P5, garden-srs
	// redesign): the strictness slider is the sole writer of `repetition` now, via
	// setStrictnessVal (live sync) and the onOk handler above (persist) — see the comment on
	// getStrictnessVal.

	// Verbs-list settings. The first two are read SERVER-side on every list load and every
	// expansion (so the badge count and the rows can never disagree), which is why they refresh the
	// word-list panel instead of being picked up from the DOM at drill time like the rows above.
	$("#verbOnlyIrregularId").change(function () {
		// Refresh only AFTER the save lands. Firing both at once races: wordlist-load would read
		// the OLD flag and paint a stale badge count, while the row fetch — one round trip later —
		// used the new one, leaving 924 over a list of 2,657.
		ajaxPostUserAttr("verbOnlyIrregular", this.checked, function () {
			if (window.onVerbListFilterToggled) {
				window.onVerbListFilterToggled();
			}
			return true;
		});
	});
	$("#verbFullParadigmId").change(function () {
		ajaxPostUserAttr("verbFullParadigm", this.checked);
	});
	// Prefill is purely presentational and read from the DOM per card, like Strict caps.
	$("#verbPronounPrefillId").change(function () {
		ajaxPostUserAttr("verbPronounPrefill", this.checked);
	});
});
